import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  //   align-items: center;
  height: 100%;
  width: 100%;
  margin-left: 50px;
`;

export const Line = styled.div`
  margin: 20px 0 60px 0;
  border: 1px solid #3c87bd;
  width: 1095px;
`;

export const Text = styled.div`
  display: flex;
  margin-top: 100px;
  margin-left: 30px;
  font-size: 20px;
  font-weight: 100px;
`;

export const ReviewBox = styled.div`
  display: flex;
  width: 413px;
  height: 173px;
  background-color: #b1e2ff;
  border-radius: 10px;
  margin-top: 30px;
  margin-left: 28px;
`;
